import { useEffect } from "react";
import { useInView } from "react-intersection-observer";


interface InViewObserverProps {
    enabled?: boolean;
    onVisible?: () => void;
    onHidden?: () => void;
    children: (inViewRef: (node?: Element | null) => void) => React.ReactElement;
}

const InViewObserver: React.FC<InViewObserverProps> = (props) => {
    const { enabled, onVisible, onHidden, children } = props;

    const { ref: inViewRef, inView } = useInView();

    useEffect(() => {
        if (!enabled) {
            return;
        }
        inView ? onVisible?.() : onHidden?.();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inView]);

    return children(inViewRef);
};

export default InViewObserver;
